import { RouteComponentProps } from 'react-router-dom';
import { subDays } from 'date-fns';
import { useWaterLevelWithObservations } from 'features/waterLevel/hooks/useWaterLevelWithObservations';
import { PageLayout, getPageStatus } from 'components/PageLayout';
import { EmbeddedWaterLevel } from './EmbeddedWaterLevel';

export const WaterLevelEmbedPage = (
  props: RouteComponentProps<{ gaugeId: string }>,
): JSX.Element => {
  const {
    match: {
      params: { gaugeId },
    },
  } = props;

  const observationsHistoryStart = subDays(new Date(), 7);

  const {
    waterLevel,
    observations = [],
    isLoading,
    error,
  } = useWaterLevelWithObservations({
    id: parseInt(gaugeId, 10),
    start: observationsHistoryStart,
    end: new Date(),
  });

  const status = getPageStatus({
    isLoading,
    isError: Boolean(error) || !waterLevel,
  });

  return (
    <PageLayout
      data-cname="WaterLevelEmbedPage"
      status={status}
      headerBarProps={status === 'ready' ? {} : { action: 'back' }}
    >
      {waterLevel && (
        <EmbeddedWaterLevel
          waterLevel={waterLevel}
          observations={observations}
        />
      )}
    </PageLayout>
  );
};
